import { infraMixin } from '@/modules/infra/mixins'
import util from '@/util'
import constants from '@/util/constants'
import { obterImagem, obterIcone } from '@/util/imagem'
import mensagens from '@/util/mensagens'
import { BSpinner, BToast } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'RedefinicaoSenhaOffice',

  components: {
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  mixins: [infraMixin],

  computed: {
    ...mapState('auth', ['logoCliente']),

    obterLogo () {
      return obterImagem('logo-office300.png')
    },
    iconePreambulo () {
      return obterIcone('icone-preambulo.png')
    },

    recuperacaoPeloSso () {
      return Boolean(this.retorno.listaDados && this.retorno.listaDados.recuperacao_pelo_sso === true)
    }
  },

  data: () => ({
    dadosFormulario: {
      tenant: '',
      token: '',
      nova_senha: '',
      confirmacao_senha: ''
    },

    retorno: {
      sucesso: false,
      mensagem: '',
      listaDeErros: [],
      listaDados: []
    },

    flags: {
      efetuandoRequisicao: false
    },

    temLogoClienteNaSessao: false
  }),

  async mounted () {
    this.ActionSetLogoCliente('')
    this.definirDadosDaUrl()
    await this.definirLogotipoPeloEscritorio(this.dadosFormulario.tenant)
  },

  methods: {
    ...mapActions('auth', [
      'ActionSetLogoCliente',
      'ActionSetEscritorio'
    ]),

    ...mapGetters('auth', [
      'temLogoCliente'
    ]),

    definirDadosDaUrl () {
      this.dadosFormulario.tenant = this.$route.params.tenant
      this.dadosFormulario.token = this.$route.params.token
      this.ActionSetEscritorio(this.dadosFormulario.tenant)
    },

    async definirLogotipoPeloEscritorio (escritorio) {
      try {
        const resposta = await this.axios.get('/escritorio/' + escritorio + '/logotipo')
        const dadosRespostaRequisicao = resposta.data.retorno

        if (dadosRespostaRequisicao.success === true) {
          this.ActionSetLogoCliente(dadosRespostaRequisicao.f_client_logo)
          this.temLogoClienteNaSessao = this.temLogoCliente()
        }
      } catch (e) {
        this.temLogoClienteNaSessao = false
      }
    },

    eventoLoginTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter) {
        this.redefinirSenha()
      }
    },

    async redefinirSenha () {
      if (this.flags.efetuandoRequisicao === true) {
        return
      }

      this.retorno.mensagem = ''
      this.retorno.sucesso = false

      const validacaoSucesso = this.validarDadosFormulario()

      if (validacaoSucesso) {
        await this.efetuarRedefinicaoSenha()
      }
    },

    validarDadosFormulario () {
      this.retorno.listaDeErros = []
      let validacaoSucesso = true

      if (util.valorVazio(this.dadosFormulario.nova_senha.trim())) {
        this.retorno.listaDeErros['f_new_password'] = 'Este campo é obrigatório'
        validacaoSucesso = false
      }

      if (util.valorVazio(this.dadosFormulario.confirmacao_senha.trim())) {
        this.retorno.listaDeErros['f_confirm_password'] = 'Este campo é obrigatório'
        validacaoSucesso = false
      }

      if (
        validacaoSucesso &&
        this.dadosFormulario.nova_senha !== this.dadosFormulario.confirmacao_senha
      ) {
        this.retorno.listaDeErros['f_confirm_password'] = 'As senhas devem coincidir'
        validacaoSucesso = false
      }

      return validacaoSucesso
    },

    irParaLoginPreambulo () {
      this.$router.push({ name: constants.nomeRotaLoginComEscritorioNaURL, params: { escritorio: this.dadosFormulario.tenant } })
    },

    async efetuarRedefinicaoSenha () {
      const resposta = await this.realizarRequisicaoRedefinicaoSenha()

      if (!util.valorVazio(resposta)) {
        this.retorno = { ...resposta.retorno }
      }
    },

    async realizarRequisicaoRedefinicaoSenha () {
      let dadosRespostaRequisicao = null
      this.flags.efetuandoRequisicao = true

      try {
        const resposta = await this.axios.post('/manager/redefinir-senha-office', {
          tenant: this.dadosFormulario.tenant,
          token: this.dadosFormulario.token,
          nova_senha: this.dadosFormulario.nova_senha,
          confirmacao_senha: this.dadosFormulario.confirmacao_senha
        })

        dadosRespostaRequisicao = resposta.data
      } catch (e) {
        this.retorno.mensagem = mensagens.falhaComunicacaoServidor
      } finally {
        this.flags.efetuandoRequisicao = false
      }

      return dadosRespostaRequisicao
    }
  }
}
